import { Outlet } from "react-router-dom"



export const CompanyAdminLayout = () => {
    return <Outlet/>;
}